import { render, staticRenderFns } from "./AppSwitcher.vue?vue&type=template&id=19b99d3a&scoped=true&"
import script from "./AppSwitcher.vue?vue&type=script&lang=js&"
export * from "./AppSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./AppSwitcher.vue?vue&type=style&index=0&id=19b99d3a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b99d3a",
  null
  
)

export default component.exports